import React, { useState } from 'react';

import Input from 'components/atoms/Input';

import SearchIcon from 'images/icon/search.inline.svg';

export const SimpleSearchInput = ({ className, onSearch = () => {}, ...other }) => {
	const [value, setState] = useState('');

	const onChange = e => setState(e.target.value);

	const onSearchCallback = () => onSearch(value);
	const onKeyPress = e => {
		if (e.key === 'Enter') {
			onSearch(value);
		}
	};

	return (
		<Input
			className={className}
			placeholder="輸入您所要搜尋的產品關鍵字"
			renderIcon={() => <SearchIcon />}
			onClickIcon={onSearchCallback}
			onChange={onChange}
			value={value}
			onKeyPress={onKeyPress}
			{...other}
		/>
	);
};

const SearchInput = ({ className, onSearch, ...other }) => {
	const [open, setState] = useState(false);

	if (open) {
		return <SimpleSearchInput className={className} onSearch={onSearch} {...other} />;
	}

	return (
		<button onClick={() => setState(true)} type="button">
			<SearchIcon />
		</button>
	);
};

export default SearchInput;
